import React from 'react';
import { FaRegCopyright } from 'react-icons/fa';
import '../App.css';

const OFFICIAL_LINKS = [
    { href: 'https://global.grandsummoners.com/', label: 'Grand Summoners Website' },
    { href: 'https://discord.gg/grandsummoners', label: 'Official Discord' },
    { href: 'https://www.facebook.com/GrandSummonersGlobal', label: 'Facebook' },
    { href: 'https://www.reddit.com/r/grandsummoners/', label: 'Reddit' },
    { href: 'https://twitter.com/GRDSMN_GLOBAL', label: 'Twitter' },
];

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="gs-footer">
            <div className="gs-footer__inner">
                <div className="gs-footer__legal">
                    <p className="gs-footer__disclaimer">
                        The website grandsummoners.info is not affiliated with nor endorsed by NextNinja.
                        All images belong to NextNinja.
                    </p>
                    <p className="gs-footer__copyright">
                        <FaRegCopyright aria-hidden="true" /> grandsummoners.info {currentYear}
                    </p>
                </div>

                <nav className="gs-footer__links" aria-label="Official links">
                    <span className="gs-footer__heading">Official Links</span>
                    <span className="gs-footer__list">
                        {OFFICIAL_LINKS.map(({ href, label }, index) => (
                            <React.Fragment key={href}>
                                {index > 0 && (
                                    <span className="gs-footer__sep" aria-hidden="true">|</span>
                                )}
                                <a href={href} target="_blank" rel="noopener noreferrer">
                                    {label}
                                </a>
                            </React.Fragment>
                        ))}
                    </span>
                </nav>
            </div>
        </footer>
    );
}

export default Footer;
